import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLazyLoad } from '../../hooks/lazy-loading';
var Image = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var Component = function Component(props) {
  var src = props.src,
      width = props.width,
      height = props.height,
      alt = props.alt,
      preload = props.preload,
      rest = __rest(props, ["src", "width", "height", "alt", "preload"]);

  var _useLazyLoad = useLazyLoad(),
      containerRef = _useLazyLoad.containerRef,
      isVisible = _useLazyLoad.isVisible;

  useEffect(function () {
    if (preload) {
      var head = document.querySelector('head');
      var link = document.createElement('link');
      link.setAttribute('rel', 'preload');
      link.setAttribute('as', 'image');
      link.setAttribute('href', src);

      if (head) {
        head.appendChild(link);
      }
    }
  }, [preload]);
  return React.createElement(Image, Object.assign({
    src: isVisible ? src : '',
    width: width,
    height: height,
    alt: alt,
    ref: containerRef
  }, rest));
};

export default Component;